export default __webpack_public_path__ + "static/media/Armguards of Courageous Souls.284ce6fc.jpg";